import React from "react";

export const ssr = {
    isSSR: true,
    toggleSSR:()=>{}
}

export const SSRContext = React.createContext(ssr)